import { render } from "./AddPlantJournalHeader.vue?vue&type=template&id=1cc2dccb"
import script from "./AddPlantJournalHeader.vue?vue&type=script&lang=js"
export * from "./AddPlantJournalHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__